import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [vip首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=120401145
export const homepage = createAsyncThunk(
  '/live/vip/homepage',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/vip/homepage',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
export const influential_user_homepage = createAsyncThunk(
  'vip/influential_user_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_vip_task_info = createAsyncThunk(
  'vip/get_vip_task_info',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/vip/get_vip_task_info',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const start_vip_limit_task = createAsyncThunk(
  'vip/start_vip_limit_task',
  async (
    params: {
      level: number
      pre_level: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/vip/start_vip_limit_task',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const slt = createAsyncThunk(
  'vip/slt',
  async (
    params: {
      level: number
      pre_level: number
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/vip/vip/slt',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_config_in_profile = createAsyncThunk(
  'vip/get_config_in_profile',
  async (params: any, store: any) => {
    // return {
    //   err_msg: '',
    //   activation_popup_info: {
    //     style_type: 1,
    //     shushu_level: 100,
    //     images: {
    //       up_bg: 'https://img01.mehiya.com/img/png/id/455623147801',
    //       down_bg: 'https://img01.mehiya.com/img/png/id/455623153776',
    //       medal: 'https://img01.mehiya.com/img/png/id/459750364341',
    //     },
    //     texts: {
    //       title: '‪Congratulations on unlocking VIP0',
    //       vip: 'VIP 0',
    //       content: '‪You have become a Top 10% elite',
    //       content_args: ['10%'],
    //     },
    //   },
    // }
    const resp = await http.post(
      '/live/vip/get_config_in_profile',
      {
        from: 'h5_vip_homepage',
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export enum TypeEnum {
  vip = 'vip',
  svip = 'svip',
}

export enum StatusEnum {
  正常 = 0,
  不是vip = 1,
  卡级 = 2,
  封禁 = 3,
  满级 = 4,
  即将到期 = 5,
}
export interface InitialStateType {
  pre_privilege_list?: Array<{
    id: number
    title: string
    icon: string
    lock_icon: string
    lock_level: number
    desc: string
    image: string
    count_map?: {
      [key: number]: number
    }
    scheme?: string
    real_icons?: any
  }>
  privilege_list?: Array<{
    id: number
    title: string
    icon: string
    lock_icon: string
    lock_level: number
    desc: string
    image: string
    count_map?: {
      [key: number]: number
    }
    scheme?: string
    real_icons?: any
  }>
  level_map?: {
    [key: number]: null
  }
  pre_level_map?: {
    [key: number]: null
  }
  user_info?: {
    name: string
    avatar: string
    level: number
    exp: number
    expire_date: string
    expire_year: string
    expire_month: string
    expire_day: string
    bubble: string
    status: StatusEnum
    vip_type: TypeEnum
    pre_level: number
    is_birth_day: boolean
    is_bonus_act_doing: boolean // 是否是膨胀活动期间
    has_bonus_buff: boolean // 是否有膨胀卡
    is_retention: boolean
    my_bonus_buff: number // 膨胀倍数
  }
  toast?: string
  ari_discount_popup?: boolean // 贵族折扣是否弹窗
  monthActivityIng?: boolean // 月度入口
  limitTask?: any
  modal: {
    activation_popup_info?: any
  }
  base: {
    fold: boolean
  }
}

const initialState: InitialStateType = {
  base: {
    fold: true,
  },
  modal: {},
}

export const VipSlice = createSlice({
  name: 'Animal_Whale',
  initialState,
  reducers: {
    updateFold: (state, action: PayloadAction<boolean>) => {
      const {base} = state
      Object.assign(state, {
        base: {
          ...base,
          fold: action.payload,
        },
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      const {user_info} = action.payload
      Object.assign(state, {
        ...action.payload,
        user_info: {
          ...user_info,
          vip_type: user_info?.vip_type || 'vip',
        },
      })
    })
    builder.addCase(get_vip_task_info.fulfilled, (state, action) => {
      Object.assign(state, {
        limitTask: action.payload,
      })
    })
    builder.addCase(get_config_in_profile.fulfilled, (state, action) => {
      Object.assign(state.modal, action.payload)
    })
    builder.addCase(influential_user_homepage.fulfilled, (state, action) => {
      const {count_down = 0} = action.payload
      Object.assign(state, {
        monthActivityIng: count_down > 0,
      })
    })
  },
})
export default VipSlice.reducer
export const VipActions = VipSlice.actions

export const useVipState = () => {
  const data = useSelector((state) => {
    return state.Animal_Whale
  })
  return data
}
